import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type PostSolasVGMRequestItem = {
  oidExport: number;
  peso: number;
};

type PostSolasVGMRequestBody = {
  items: PostSolasVGMRequestItem[];
  listadoAgencia?: string;
};

type PostSolasVGMResponse = {
  state: number;
};

export const postSolasVGM = async (
  payload: PostSolasVGMRequestBody
): Promise<PostSolasVGMResponse> => {
  try {
    const res = await apiClient.post<PostSolasVGMResponse>(
      Endpoints.SOLASEditVGM,
      payload
    );
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.message);
    }
    throw error;
  }
};
